/** A little function to help us with reordering the result */
export const reorder = <T>(list, startIndex: number, endIndex: number) => {
  const result = Array.from(list)
  const [removed] = result.splice(startIndex, 1)
  result.splice(endIndex, 0, removed)

  return result as T[]
}
